var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"label":"照片","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-popover',{attrs:{"placement":"left","width":"300","trigger":"hover","popper-class":"photo"}},[_c('img',{attrs:{"src":row.photo}}),_c('img',{attrs:{"slot":"reference","src":row.photo},slot:"reference"})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }